import React, { Component } from "react";
import EachFeedback from "./eachFeadback";
import Pagination from "./pagination";
import axios from "axios";

export class Feedbacks extends Component {
  state = {
    feedbacks: "",
    current_page: 1,
    feedbacks_per_page: 5,
  };

  componentDidMount() {
    this.get_data();
  }

  get_data = async () => {
    this.setState({
      loading: true,
    });

    const response = await axios.get(`/feedback`);
    this.setState({
      feedbacks: response.data.data,
    });
    this.setState({
      loading: false,
    });
  };

  render() {
    const { current_page, feedbacks_per_page, feedbacks } = this.state;

    const index_of_last_feedback = current_page * feedbacks_per_page;
    const index_of_first_feedback = index_of_last_feedback - feedbacks_per_page;
    const current_feedbacks = feedbacks.slice(
      index_of_first_feedback,
      index_of_last_feedback
    );

    const paginate = (pageNum) => {
      this.setState({ current_page: pageNum });
    };
    const nextPage = (num) => {
      this.setState({
        current_page: current_page + num,
      });
    };

    const prevPage = (num) => {
      this.setState({
        current_page: current_page - num,
      });
    };

    return (
      <div>
        <h3 className="mb-5 ">Feedbacks</h3>
        <EachFeedback feedbacks={current_feedbacks} />
        <Pagination
          feedbacks_per_page={feedbacks_per_page}
          total_feedbacks={feedbacks.length}
          paginate={paginate}
          nextPage={nextPage}
          prevPage={prevPage}
          current_page={current_page}
        />
      </div>
    );
  }
}

export default Feedbacks;
